import React from 'react';
import { Col, Card, Row, Button } from "react-bootstrap";
import { FaCalendarAlt } from 'react-icons/fa'; // Importa ícone de calendário

const styles = {
  card: {
    backgroundColor: "#17296B",
    height: '100%',
  },
  container: {
    margin: '1rem',
  },
  rowBorder: {
    borderBottom: '1px solid #fff',
    paddingBottom: '10px',
    marginBottom: '10px',
  },
  colTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#fff',
  },
  title: {
    fontSize: "2.5vmin",
  },
  contentContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100% - 10.1rem)",
    marginTop: "10px",
  },
  iconCalendar: {
    fontSize: "2vw",
    color: '#fff',
  },
  messageText: {
    fontSize: "2.2vmin",
  },
  button: {
    width: '20%',
    color: '#fff',
    border: 'none',
  },
  buttonApprove: {
    backgroundColor: '#228B22', // Verde
  },
  buttonReject: {
    backgroundColor: '#8B0000', // Vermelho
  },
};

const AdminInbox = () => (
  <Col className='col-6'>
    <Card className='rounded-4 shadow' style={styles.card}>
      <div style={styles.container}>
        <Row className='border-bottom'>
          <Col style={styles.colTitle}>
            <b style={styles.title}>Caixa de Entrada</b>
          </Col>
        </Row>
        <div style={styles.contentContainer}>
          <Row className='d-flex flex-column gap-3 text-white'>
            {[
              { title: "Título 1", description: "Descrição longa sobre o evento 1." },
              { title: "Título 2", description: "Descrição longa sobre o evento 2." },
            ].map((message, index) => (
              <Col key={index} style={styles.rowBorder}>
                <Row className='align-items-center'>
                  <Col className='d-flex align-items-center gap-2'>
                    <FaCalendarAlt style={styles.iconCalendar} /> {/* Ícone de calendário à esquerda */}
                    <div>
                      <b style={styles.messageText}>{message.title}</b>
                      <p style={styles.messageText}>{message.description}</p>
                    </div>
                  </Col>
                </Row>
                <Row className='d-flex justify-content-start gap-2 mt-2 m-2'>
                  <Button style={{ ...styles.button, ...styles.buttonReject }}>Recusar</Button>
                  <Button style={{ ...styles.button, ...styles.buttonApprove }}>Aceitar</Button>
                </Row>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </Card>
  </Col>
);

export default AdminInbox;
